import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { SafePipe } from 'src/app/core/pipes/safe.pipe';
import { SocialMediaFileDirective } from '../../../core/directives/social-media-file.directive';
import { FileControllerComponent } from './file-controller.component';

@NgModule({
  declarations: [FileControllerComponent],
  imports: [CommonModule, SocialMediaFileDirective, SafePipe, TranslateModule],
  exports: [FileControllerComponent],
})
export class FileControllerModule {}
